import React from "react";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title = "Confirmation",
  message,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  return (
    <Modal open={open} onClose={onCancel} title={title}>
      <div className="text-md pb-6">{message}</div>
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          onClick={onCancel}
          fullWidth
          isLoading={isLoading}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          fullWidth
          isLoading={isLoading}
          disabled={isLoading}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
